import { ChevronLeftIcon, ChevronRightIcon } from '@sketchnote/icons';
import cn from 'classnames';
import { useMemo } from 'react';
import { NavigateAction, ToolbarProps, View } from 'react-big-calendar';

export const Toolbar = ({
  label,

  localizer: { messages },
  onNavigate,
  onView,
  views,
  view: currentView,
}: ToolbarProps) => {
  const navigate = (action: NavigateAction) => () => {
    onNavigate(action);
  };

  const onViewChange = (view: View) => () => {
    onView(view);
  };

  const buttonMessage = useMemo(() => {
    switch (currentView) {
      case 'month':
        return label;
      case 'week':
        return 'This week';
      case 'work_week':
        return 'This week';
      case 'day':
        return 'Today';
      case 'agenda':
        return label;
      default:
        return messages.today;
    }
  }, [currentView]);

  return (
    <div className="flex justify-between mb-32 text-sm">
      <div className="text-gray-500 text-xl font-semibold w-332">{label}</div>
      <div className="flex">
        {(views as View[]).map((view, index) => (
          <button
            className={cn('px-8 py-2 capitalize border-t border-b border-r text-gray-500', {
              'border-l rounded-tl-lg rounded-bl-lg': index === 0,
              'rounded-tr-lg rounded-br-lg': index === (views as View[]).length - 1,
              'text-primary-500 border-primary-500 border-l': view === currentView,
            })}
            key={view}
            onClick={onViewChange(view)}
          >
            {view.replace('_', ' ')}
          </button>
        ))}
      </div>
      <div className="flex items-center text-gray-600 w-332 justify-end">
        <button type="button" onClick={navigate('PREV')} className="flex items-center">
          <ChevronLeftIcon className="mt-1" />
        </button>
        <button type="button" onClick={navigate('TODAY')} className="mx-12">
          {buttonMessage}
        </button>
        <button type="button" onClick={navigate('NEXT')} className="flex items-center">
          <ChevronRightIcon />
        </button>
      </div>
    </div>
  );
};
